import { I18NText, Language } from 'src/types'
import EN from 'src/locales/en'
import ZH_TW from 'src/locales/zh-TW'

export const getI18NText = (language: Language, t: I18NText) => {
  if (language === 'en') return EN
  if (language === 'zh-TW') return ZH_TW
  return t
}
